import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import type Controller from '@ember/controller';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';
import {
  scrollRhsToTop,
  loadAiSettingsIfPermitted,
} from 'uplisting-frontend/pods/-sidebar/utils';

interface IParams extends Record<string, unknown> {
  booking_request_id: string;
}

export default abstract class SidebarBookingRequestsRoute extends PermittedRoute {
  @service features!: Services['features'];

  permission = 'calendar.booking-requests';

  async model(params: IParams) {
    const [bookingRequest] = await Promise.all([
      this.store.findRecord('booking-request', params.booking_request_id, {
        reload: true,
        include: this.include,
      }),
      loadAiSettingsIfPermitted(this),
    ]);

    return bookingRequest;
  }

  private get include(): string {
    const include = [
      'channel_user',
      'property',
      'price',
      'ai_occasion_context',
    ];

    if (this.features.isInboxAssignmentEnabled) {
      include.push('inbox_message');
    }

    return include.join(',');
  }

  setupController(controller: Controller, model, transition: Transition): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { bookingRequest: model });

    scrollRhsToTop(this);
  }
}
